define(
    'viewmodels/secured/libraries/fields',[
        "durandal/app",
        "viewmodels/ViewModelNotification",
        "providers/dataprovider",
        "i19n!i19n/strings",
        "services/service.dialog"
    ],
    function (app, ViewModelNotification, dataProvider, i19n, dialogService) {

        var gridfields = null;
        var $gridfields = null;
        var gridvalues = null;
        var $gridvalues = null;

        var vm = new ViewModelNotification(
        {
            id: '',
            notify: {},
            reload: {},
            comboClick: {},
            i19n: i19n,

            isGridValuesVisible: ko.observable(false),
            //gridValuesLoading: $.Deferred(),

            lookupId: ''
        });

        vm.activate = function () {
            vm.lookupId = '';
        };
        vm.attached = function () {
            $gridfields = $("#fields-grid");
            $gridvalues = $("#values-grid");

            buildGridFields();
            buildGridValues();               

            gridfields.table.off("click", ":checkbox", displayInProfileClick);
            gridfields.table.on("click", ":checkbox", displayInProfileClick);

            gridvalues.table.off("click", ".isincluded-id:checkbox", isIncludedClick);
            gridvalues.table.on("click", ".isincluded-id:checkbox", isIncludedClick);
            
            function buildGridFields() {
                gridfields = $gridfields.kendoGrid({
                    dataSource: getGridFieldsDataSource(),
                    dataBound: function () {
                        //var grid = this;

                        //var data = gridfields.dataSource.view();
                        //for (var i = 0; i < data.length; i++) {
                        //    if (!data[i].isLookup) {
                        //        var $tr = gridfields.table.find("tr[data-uid='" + data[i].uid + "']");

                        //        $tr.find(".k-grid-addfieldvalue").hide();
                        //    }                            
                        //}
                    },
                    resizable: true,
                    reorderable: true,
                    sortable: true,
                    selectable: "row",
                    columns: [
                        { field: "id", hidden: true },
                        { field: "isDisplayedInProfile", title: i19n.to.show, width: 60, template: "<input class='k-grid-isDisplayedInProfile' style='height:18px' type='checkbox' data-bind='checked:isDisplayedInProfile' #= isDisplayedInProfile? 'checked=checked' : '' # />" },
                        { field: "fieldName", title: i19n.to.field, width: 160 },
                        { field: "fieldType", title: i19n.to.type },
                        //{
                        //    command: {
                        //        name: "addfieldvalue",
                        //        text: i19n.to.addfieldvalue,
                        //        click: function (e) {
                        //            e.preventDefault();

                        //            var $row = $(e.target).closest('tr');
                        //            var row = this.dataItem($row);

                        //            this.select($row);

                        //            gridValuesLoading
                        //            .done(function () {
                        //                setTimeout(function () {
                        //                    vm.notify("");
                        //                    gridvalues.addRow();
                        //                }, 10);
                        //            });

                        //            return false;
                        //         }
                        //    },
                        //    width: 130
                        //}
                    ],
                    scrollable: true,
                    editable: { mode: "inline" },
                    height: 500,
                    change: function (e) {
                        var row = this.dataItem(this.select());
                        
                        vm.lookupId = row.fieldType.toLowerCase() == "lookup" ? row.lookupId : "";

                        //gridValuesLoading = $.Deferred();
                        vm.isGridValuesVisible(row.isLookup);
                        gridvalues.dataSource.read();                        
                    }
                }).data("kendoGrid");
            };
            function getGridFieldsDataSource() {
                return new kendo.data.DataSource({
                    transport: {
                        read: function (callbacks) {
                            dataProvider.libraries
                            .getProfileFieldLookups(vm.id)
                            .done(function (data) {
                                var list = data.profileFieldVisibility || [];

                                list = _.map(list, function (itm) {
                                    itm.isLookup = !(!itm.fieldType) && itm.fieldType.toLowerCase() == "lookup";
                                   
                                    return itm;
                                });

                                list = _.sortBy(list, function (itm) {
                                    var i = itm.isDisplayedInProfile ? 0 : 1;
                                    return [i, itm.fieldName].join("_");
                                });

                                callbacks.success(list);
                            })
                            .fail(function (e) {
                                vm.notify(e.error);

                                console.error(e);
                            })
                            .always(function () {
                                setTimeout(function () {
                                    resizeGrid();
                                }, 200);
                            });
                        }
                    },
                    //sort: [{ field: "isDisplayedInProfile", dir: "desc" }, { field: "fieldName", dir: "asc" }],
                    schema: {
                        model: {
                            id: "documentFieldId",
                            fields: {
                                documentFieldId: { type: "string" },
                                lookupId: { type: "string" },
                                isDisplayedInProfile: { type: "bool" },
                                fieldName: { type: "string" },
                                fieldType: { type: "string" }
                            }
                        }
                    },
                    pageSize: 999
                });
            }

            function buildGridValues() {
                gridvalues = $gridvalues.kendoGrid({
                    dataSource: getGridValuesDataSource(),
                    resizable: true,
                    reorderable: true,
                    sortable: true,
                    columns: [
                        { field: "id", hidden: true },
                        { field: "isIncluded", title: i19n.to.include, width: 60, template: "<input class='isincluded-id' style='height:18px' type='checkbox' data-bind='checked:isIncluded' #= isIncluded? 'checked=checked' : '' # />" }, //onClick='return false'
                        { field: "name", title: i19n.to.fieldvalue },
                        {
                            command: [
                              { name: "edit", text: i19n.to.edit },
                              { name: "destroy", text: i19n.to.delete }
                            ],
                            title: "&nbsp;",
                            width: 170
                        }
                    ],
                    scrollable: { virtual: true },
                    editable: { mode: "inline" },
                    height: 500
                }).data("kendoGrid");
            };
            function getGridValuesDataSource() {
                return new kendo.data.DataSource({
                    transport: {
                        read: function (callbacks) {

                            if (vm.lookupId == '') {
                                callbacks.success([]);

                                return;
                            }

                            dataProvider.libraries
                            .getProfileFieldValues(vm.lookupId, vm.id)
                            .done(function (data) {
                                data = _.sortBy(data, function (itm) { return itm.name; });
                                
                                callbacks.success(data);

                                //setTimeout(function () {                                    
                                //    callbacks.success(data);
                                //    gridValuesLoading.resolve();
                                //}, 500);
                            })
                            .fail(function (e) {
                                //setTimeout(function () {
                                //    gridValuesLoading.resolve();
                                //}, 500);

                                vm.notify(e.error);

                                console.error(e);
                            })
                            .always(function () {
                                setTimeout(function () {
                                    resizeGrid();
                                }, 200);
                            });
                        },
                        update: function (callbacks) {
                            dataProvider.libraries
                            .updateProfileFieldValues(callbacks.data.id, callbacks.data.lookupId, { name: callbacks.data.name, isIncluded: callbacks.data.isIncluded })
                            .done(function (result) {
                                vm.notify('');
                                vm.notify('success', callbacks.data.name + ' ' + i19n.to.updated);

                                dataProvider.libraries
                                .includeProfileFieldValueToLibrary(callbacks.data.id, vm.id, callbacks.data.isIncluded)
                                .done(function (result) {
                                    vm.notify('success', callbacks.data.name + ' ' + (callbacks.data.isIncluded ? i19n.to.hasbeenincludedinlibrary : i19n.to.hasbeenexcludedfromlibrary));

                                    callbacks.success();
                                })
                                .fail(function (e) {
                                    e.stopPropagation = true;

                                    vm.notify(e.error);

                                    callbacks.error(e.error);

                                    console.error(e);
                                });
                            })
                            .fail(function (e) {
                                e.stopPropagation = true;

                                vm.notify(e.error);

                                callbacks.error(e.error);

                                console.error(e);
                            });
                        },
                        create: function (callbacks) {
                            dataProvider.libraries
                            .createProfileFieldValues(vm.lookupId, { name: callbacks.data.name, isIncluded: callbacks.data.isIncluded })
                            .done(function (result) {
                                vm.notify('success', callbacks.data.name + ' ' + i19n.to.updated);

                                gridvalues.dataSource.read();

                                if (callbacks.data.isIncluded) {
                                    dataProvider.libraries
                                    .includeProfileFieldValueToLibrary(result, vm.id, true)
                                    .done(function (result) {

                                        callbacks.success();

                                        vm.notify('success', callbacks.data.name + ' ' + i19n.to.hasbeenincludedinlibrary);
                                    })
                                    .fail(function (e) {
                                        e.stopPropagation = true;

                                        vm.notify(e.error);

                                        console.error(e);
                                    });
                                } else {
                                    callbacks.success();
                                }
                            })
                            .fail(function (e) {
                                e.stopPropagation = true;

                                vm.notify(e.error);

                                callbacks.error(e.error);

                                console.error(e);
                            });
                        },
                        destroy: function (callbacks) {
                            var dialogoptions = { ok: { label: 'Yes', message: '' }, cancel: { label: 'No', message: '' } };

                            dialogService.showMessageBox(i19n.to.confirmdelete, i19n.to.delete + ' ' + callbacks.data.name + ' ?', _.toArray(dialogoptions))
                            .then(function (action) {
                                if (action == dialogoptions.cancel) {
                                    gridvalues.cancelChanges();
                                }
                                if (action == dialogoptions.ok) {
                                    dataProvider.libraries
                                    .includeProfileFieldValueToLibrary(callbacks.data.id, vm.id, false)
                                    .done(function (result) {
                                        vm.notify('success', callbacks.data.name + ' ' + i19n.to.hasbeenexcludedfromlibrary);

                                        dataProvider.libraries
                                        .deleteProfileFieldValues(vm.lookupId, callbacks.data.id)
                                        .done(function (result) {
                                            vm.notify('success', callbacks.data.name + ' ' + i19n.to.deleted);

                                            callbacks.success();
                                        })
                                        .fail(function (e) {
                                            e.stopPropagation = true;

                                            gridvalues.cancelChanges();

                                            callbacks.error(e.error);

                                            console.error(e);
                                        });
                                    })
                                    .fail(function (e) {
                                        e.stopPropagation = true;

                                        vm.notify(e.error);

                                        console.error(e);
                                    });
                                }
                            });
                        }
                    },
                    schema: {
                        model: {
                            id: "id",
                            fields: {
                                id: { type: "string" },
                                isIncluded: { type: "boolean" },
                                name: { type: "string" }
                            }
                        }
                    },
                    pageSize: 999
                });
            }

            function displayInProfileClick(e) {
                var row = gridfields.dataItem($(this).closest("tr"));

                row.isDisplayedInProfile = !row.isDisplayedInProfile;

                e.stopPropagation();
                
                saveFields(row.fieldName);
            }
            function isIncludedClick(e) {
                var row = gridvalues.dataItem($(this).closest("tr"));
                var val = !row.isIncluded;

                row.isIncluded = val;

                $(this).prop('checked', val);

                e.stopPropagation();

                saveFieldValues(row.id, row.lookupId, row.name, val);
            }

            $(window).off("resize", _.debounce(resizeGrid, 250));
            $(window).on("resize", _.debounce(resizeGrid, 250));            
        };

        //vm.saveClick = function () {
        //    saveFields();
        //};
        //vm.cancelClick = function () {
        //    gridfields.dataSource.read();
        //};

        vm.addFieldValue = function () {
            setTimeout(function () {
                vm.notify("");

                gridvalues.addRow();
            }, 10);
        };

        return vm;

        function resizeGrid() {
            var h = $("#content").outerHeight() - 283;

            $gridfields.height(h);
            gridfields.resize();

            $gridvalues.height(h - 33);
            gridvalues.resize();
        }

        function saveFields(fieldName) {
            //var fields = _.filter(self.updateFields, function (itm) {                
            //    return itm != null;
            //});

            var fields = _.map(gridfields._data, function (itm) {
                return {
                        documentFieldId: itm.documentFieldId,
                        isDisplayedInProfile: itm.isDisplayedInProfile,
                        fieldName: itm.fieldName
                };
            });

            dataProvider.libraries
            .updateProfileFields(vm.id, fields)
            .done(function (result) {
                vm.notify('');
                vm.notify('success', fieldName + ' ' + i19n.to.updated); //i19n.to.libraryfields
            })
            .fail(function (e) {
                e.stopPropagation = true;

                vm.notify(e.error);

                console.error(e);
            });
        }
        function saveFieldValues(id, lookupId, name, isIncluded) {
            dataProvider.libraries
            .updateProfileFieldValues(id, lookupId, { name: name, isIncluded: isIncluded })
            .done(function (result) {
                vm.notify('');
                vm.notify('success', name + ' ' +i19n.to.updated);

                dataProvider.libraries
                .includeProfileFieldValueToLibrary(id, vm.id, isIncluded)
                .done(function (result) {
                    vm.notify('');
                    vm.notify('success', name + ' ' + (isIncluded ? i19n.to.hasbeenincludedinlibrary : i19n.to.hasbeenexcludedfromlibrary));
                })
                .fail(function (e) {
                    e.stopPropagation = true;

                    vm.notify(e.error);

                    console.error(e);
                });
            })
            .fail(function (e) {
                e.stopPropagation = true;

                vm.notify(e.error);

                console.error(e);
            });
        }
});
